import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import chat from './chat';
import user from './user';
import consults from './consults';
import info from './info';
import prescription from './prescription';
import savedPrescription from './savedPrescription';
import symptoms from './symptoms';
import conditions from './conditions';
import filters from './filters';
import videoFeedback from './videoFeedback';
import digitisation from './digitisation';
import digitisationPincode from './digitisationPincode';
import videoSession from './videoSession';
import consultation from './consultation';
import loginError from './loginError';
import lastDigitisation from './lastDigitisation';
import fwaDigi from './fwaDigi';

// `sponsors` is a ~68k-item array that is re-fetched on the dashboard. Persisting
// it pushed the localStorage blob past the ~5MB quota, which made redux-persist's
// write silently fail for the whole store (auth token included) — logging the user
// out on refresh. Persist the rest of `info` (verticals, prescriptions…), never sponsors.
const infoPersistConfig = {
  key: 'info',
  storage,
  blacklist: ['sponsors'],
};

export default {
  app,
  chat,
  consults,
  user,
  info: persistReducer(infoPersistConfig, info),
  prescription,
  savedPrescription,
  symptoms,
  conditions,
  filters,
  videoFeedback,
  digitisation,
  digitisationPincode,
  videoSession,
  consultation,
  loginError,
  lastDigitisation,
  fwaDigi,
};
